import { BottomSheetModalMethods } from '@gorhom/bottom-sheet/lib/typescript/types'
import React, { RefObject, createContext, useContext } from 'react'

const createPostModalContext = createContext<RefObject<BottomSheetModalMethods> | null>(null)

type CreatePostModalProviderProps = {
  createPostModalRef: RefObject<BottomSheetModalMethods>
  children: React.ReactNode
}

const CreatePostModalProvider = ({
  createPostModalRef,
  children,
}: CreatePostModalProviderProps) => {
  return (
    <createPostModalContext.Provider value={createPostModalRef}>
      {children}
    </createPostModalContext.Provider>
  )
}

const useCreatePostModal = () => {
  const createPostModalRef = useContext(createPostModalContext)
  return createPostModalRef
}

export { CreatePostModalProvider, useCreatePostModal }
